import { createGlobalStyle } from 'styled-components';
import { RED, GRAY_DE, LINK_BLUE } from 'styles/colors';

const FormControlStyles = createGlobalStyle`
  .FormControl {
    position: relative;

    &__input {
      transition: 0.3s ease padding-left;
    }

    &--focused .FormControl__InputLabel--shrink {
      color: ${LINK_BLUE};
    }

    &--error .FormControl__InputLabel {
      color: ${RED};
    }

    &__Input.FormControl__Input--disabled {
      border-radius: 4px;
      background-color: rgba(63, 63, 63, 0.08);
    }

    &__Input--focused fieldset {
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.24);
      background: transparent;
    }

    &__InputLabel {
      font-family: $default-font-family;
      font-weight: 700;
      color: rgba(118, 118, 118, 0.5);
      &--hasLabelIcon {
        transform: translate(40px, 20px) scale(1);
      }
    }

    &__Input--hasLabelIcon {
      .FormControl__input {
        padding-left: 38px;
      }
      &.FormControl__Input--focused,
      &.FormControl__Input--hasValue {
        .FormControl__input {
          padding-left: 14px;
        }
      }
    }

    &__InputLabel.FormControl__InputLabel--disabled {
      color: rgba(118, 118, 118, 0.5);
    }

    &__LabelIcon {
      color: ${GRAY_DE};
      position: absolute;
      top: 27px;
      left: 8px;
    }
  }
`;

export default FormControlStyles;
